import React from 'react';
import ReactEcharts from 'echarts-for-react';

const SimpleChart = ({ type = 'bar', categories = [], series = [], height = 300, options = {} }) => {
    const getChartOptions = () => {
        // Validate data
        if (!categories || categories.length === 0) {
            console.warn('SimpleChart: No categories provided');
        }
        if (!series || series.length === 0) {
            console.warn('SimpleChart: No series provided');
        }
        
        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: series.map(s => s.name),
                bottom: 10
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '15%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: categories,
                axisLabel: {
                    interval: categories.length > 15 ? 'auto' : 0,
                    rotate: categories.length > 8 ? 45 : 0,
                    fontSize: 10
                }
            },
            yAxis: {
                type: 'value'
            },
            series: series.map(s => ({
                name: s.name,
                type: type === 'area' ? 'line' : type,
                data: s.data,
                // Forwarded only when the caller sets them, so existing charts
                // keep ECharts' default palette and stay unstacked.
                ...(s.color ? { itemStyle: { color: s.color } } : {}),
                ...(s.stack ? { stack: s.stack } : {}),
                ...(type === 'area' ? { areaStyle: {} } : {})
            })),
            ...options
        };
    };

    return (
        <ReactEcharts
            option={getChartOptions()}
            style={{ height: `${height}px` }}
            opts={{ renderer: 'canvas' }}
        />
    );
};

export default SimpleChart;